// Auth utilities
import { UserPayload, AuthResponse } from '../types';

const TOKEN_KEY = 'kig_admin_token';
const USER_KEY = 'kig_admin_user';

export const auth = {
  setToken: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
  },
  
  getToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
  },
  
  removeToken: (): void => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  
  setUser: (user: UserPayload): void => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  
  getUser: (): UserPayload | null => {
    const userStr = localStorage.getItem(USER_KEY);
    if (!userStr) return null;
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  },
  
  isAuthenticated: (): boolean => {
    return !!auth.getToken();
  },
  
  getAuthHeader: (): string => {
    const token = auth.getToken();
    return token ? `Bearer ${token}` : '';
  },
};

export default auth;

